"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-sixteen/section/companySection.tsx */

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import { SmartImage } from "@/Components";
import { FC, ComponentProps } from "react";

type HomeSixteenCompanySectionCompaniesItem = {
    /** Detected variants: "/Templates/Doccure/img/company/company-sixteen-1.svg`" | "/Templates/Doccure/img/company/company-sixteen-2.svg`" | "/Templates/Doccure/img/company/company-sixteen-3.svg`" | "/Templates/Doccure/img/company/company-sixteen-4.svg`" | "/Templates/Doccure/img/company/company-sixteen-5.svg`" | "/Templates/Doccure/img/company/company-sixteen-6.svg`" */
    src: string;
    /** Detected variants: "company-sixteen-1.svg" | "company-sixteen-2.svg" | "company-sixteen-3.svg" | "company-sixteen-4.svg" | "company-sixteen-5.svg" | "company-sixteen-6.svg" */
    text: string;
    /** Detected variants: "img" */
    alt?: string;
};
export type HomeSixteenCompanySectionGeneratedProps = {
    companies?: HomeSixteenCompanySectionCompaniesItem[];
    divDiv0Swiper0SwiperProps?: Partial<ComponentProps<typeof Swiper>>;
};

const HomeSixteenCompanySectionGenerated: FC<HomeSixteenCompanySectionGeneratedProps> = ({
    companies = [],
    divDiv0Swiper0SwiperProps,
}) => {
    return (
        <div className="company-section-sixteen section">
            <div className="container">
                <Swiper modules={[Autoplay]} slidesPerView={6} loop={true} speed={2000} autoplay={{ delay: 0, disableOnInteraction: false }} breakpoints={{
                    1400: { slidesPerView: 6 },
                    1200: { slidesPerView: 5 },
                    992: { slidesPerView: 4 },
                    768: { slidesPerView: 3 },
                    576: { slidesPerView: 2 },
                    0: { slidesPerView: 2 }
                }} className="company-slider" {...(divDiv0Swiper0SwiperProps ?? {})}>
                    {companies.map((img, index) => (
                        <SwiperSlide key={index} className="slide-item">
                            <div className="company-item-sixteen">
                                <SmartImage src={img.src} alt={img.alt ?? "img"} />
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
};

export default HomeSixteenCompanySectionGenerated;
